<template>
	<div class="cart-list__table-item grid-x">
		<!-- Insurance -->
		<template v-if="addon == 'insurance'">
			<div class="cart-list__table-label cell small-9 medium-8">
				<div class="input-wrapper">
					<Checkbox
						:cartStyling="true"
						:lightTheme="true"
						:isChecked="isChecked"
						:stringId="id"
						:label="$t('cart.insurance')"
						:isDisabled="isDisabled"
						@check-input="
							(val, id) => {
								onChangeInsurance(val, id, addon)
							}
						"
					/>
					<Tooltip
						v-if="tooltipTitle || tooltipText"
						:title="tooltipTitle"
						:text="[tooltipText]"
					/>
				</div>
			</div>
			<div class="cart-list__table-unit-price cell show-for-medium medium-2">
				<span>{{ convertPrice(price) }} SEK</span>
			</div>
			<div class="cart-list__table-price cell show-for-medium medium-2">
				<span>{{ convertPrice(isChecked * price) }} SEK</span>
			</div>

			<!-- Mobile version of á price and total price -->
			<div class="cart-list__table-price cell small-3 hide-for-medium">
				<span>
					<span v-if="!isChecked" style="color: #cdcdcd;">
						{{ convertPrice(price) }} SEK
					</span>
					<span v-else>{{ convertPrice(isChecked * price) }} SEK</span>
				</span>
			</div>
		</template>

		<!-- Comment -->
		<template v-if="addon == 'comment'">
			<div class="cart-list__table-label cell small-12">
				<div class="input-wrapper">
					<Checkbox
						:cartStyling="true"
						:lightTheme="true"
						:isChecked="isChecked"
						:stringId="id"
						:label="label"
						:isDisabled="isDisabled"
						@check-input="
							(val, id) => {
								onChangeCommentToggle(val, id, addon)
							}
						"
					/>
					<Tooltip
						v-if="tooltipTitle || tooltipText"
						:title="tooltipTitle"
						:text="[tooltipText]"
					/>
				</div>
				<Textarea
					v-show="showExtra"
					:cartStyling="true"
					:lightTheme="true"
					:stringId="id"
					:value="value"
					:isDisabled="isDisabled"
					@textarea="
						val => {
							onChangeComment(val, id, addon)
						}
					"
				/>
			</div>
		</template>

		<!-- Delivery -->
		<template v-if="addon == 'delivery'">
			<div class="cart-list__table-label cell small-9 medium-8">
				<div class="input-wrapper">
					<Checkbox
						:cartStyling="true"
						:lightTheme="true"
						:isChecked="isChecked"
						:stringId="id"
						:label="'Utkörning av utrustning'"
						:isDisabled="isDisabled"
						@check-input="
							(val, id) => {
								onChangeDeliveryToggle(val)
							}
						"
					/>
					<Tooltip
						v-if="tooltipTitle || tooltipText"
						:title="tooltipTitle"
						:text="[tooltipText]"
					/>
				</div>
				<Select
					v-if="showExtra"
					:lightTheme="true"
					placeholder="Välj utlämningsadress"
					:option-items="createDeliveryArray(cart.accommodation)"
					:value="deliveryTypeValue"
					:isDisabled="isDisabled"
					@input="
						val => {
							onChangeDeliveryType(val)
						}
					"
				/>
				<Textarea
					v-if="deliveryTypeValue == '1'"
					:cartStyling="true"
					:lightTheme="true"
					:stringId="id"
					:value="cart.delivertoother"
					:isDisabled="isDisabled"
					@textarea="
						val => {
							onChangeDelivery(val, id, addon)
						}
					"
				/>
			</div>
			<div class="cart-list__table-unit-price cell show-for-medium medium-2">
				<span>{{ convertPrice(price) }} SEK</span>
			</div>
			<div class="cart-list__table-price cell show-for-medium medium-2">
				<span>{{ convertPrice(isChecked * price) }} SEK</span>
			</div>

			<!-- Mobile version of á price and total price -->
			<div class="cart-list__table-price cell small-3 hide-for-medium">
				<span>
					<span v-if="!isChecked" style="color: #cdcdcd;">
						{{ convertPrice(price) }} SEK
					</span>
					<span v-else>{{ convertPrice(isChecked * price) }} SEK</span>
				</span>
			</div>
		</template>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Checkbox from '../atoms/Checkbox'
import Textarea from '../atoms/Textarea'
import Select from '../atoms/Select'
import Tooltip from '../molecules/Tooltip'

export default {
	name: 'ProductAddon',
	store,
	mixins: [mixin],
	components: {
		Checkbox,
		Textarea,
		Select,
		Tooltip
	},
	props: {
		id: {
			type: [String, Number],
			default: ''
		},
		addon: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		price: {
			type: Number,
			default: 0
		},
		isChecked: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		tooltipTitle: {
			type: String,
			default: ''
		},
		tooltipText: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			showExtra: this.isChecked
		}
	},
	computed: {
		cart() {
			return store.state.cart
		},
		delivery() {
			return store.state.cart.delivery
		},
		deliveryTypeValue() {
			if (this.cart.delivertoaccommodation) {
				return this.cart.delivertoaccommodation
			}
			if (this.cart.delivertoother || this.cart.delivertoother == '') {
				return '1'
			}
			return ''
		}
	},
	methods: {
		createDeliveryArray(accommodations) {
			var array = [{ id: 1, text: this.$t('cart.deliveryTextareaOption') }]
			var object = {}

			for (var i = 0; i < accommodations.length; i++) {
				object = {
					id: accommodations[i].unitlid,
					text: accommodations[i].title
				}
				array.unshift(object)
			}
			return array
		},
		onChangeInsurance(event, id, type) {
			this.$emit('on-change-insurance', event, id, type)
		},
		onChangeCommentToggle(event, id, type) {
			this.showExtra = event

			//Emit empty value -> clear value in store
			this.$emit('on-change-comment', '', id, type)
		},
		onChangeComment(event, id, type) {
			this.$emit('on-change-comment', event, id, type)
		},
		onChangeDeliveryToggle(event) {
			this.showExtra = event
			this.$emit('on-change-delivery', event) //val=true/false
		},
		onChangeDeliveryType(val) {
			//Free text option
			if (val == 1) {
				this.$emit('on-change-delivery', val)

				//Accommodation option
			} else {
				this.$emit('on-change-delivery', val) //val=accId
			}
		},
		onChangeDelivery(val) {
			this.$emit('on-change-delivery', val, 'other') //val=textareaString
		}
	}
}
</script>

<style scoped lang="scss"></style>
